'use client'
import React from 'react'

import BreadCrumbs from '../../sections/breadcrumbs'
import Article from '../../sections/article'
import NewsShortSection from '../../sections/newsShortSection'

const EventDetailPage = ({
  title,
  info_lists,
  intro_text,
  get_snel_naar,
  body,
  event_start,
  event_end,
  breadcrumbs,
  sports,
  category,
  in_past,
  host,
  news,
  locationsAddresses,
  clubLinks,
  globalTags,
}) => {
  const intro_link = get_snel_naar && get_snel_naar[0] && get_snel_naar[0].value
  const article = intro_text ? intro_text.concat(body) : body || []

  const tags = []
  if (category) {
    tags.push({ name: category })
  }
  if (sports && sports.length > 0) {
    sports.forEach((item) => {
      tags.push({
        name: item.title,
      })
    })
  }
  if (globalTags) {
    globalTags.forEach((item) => {
      tags.push({
        name: `${item.title}`,
      })
    })
  }
  return (
    <>
      <BreadCrumbs breadcrumbs={breadcrumbs} spacing={60} />
      <Article
        title={title}
        startdate={event_start}
        enddate={event_end}
        tags={tags}
        article={article}
        link={intro_link}
        lists={info_lists}
        locationsAddresses={locationsAddresses}
        clubLinks={clubLinks}
        inPast={in_past}
        host={host}
      />
      {news?.news && news?.news?.length > 0 ? (
        <NewsShortSection
          title={news?.title}
          button={false}
          news={news?.news}
          inArticle={true}
        />
      ) : null}
    </>
  )
}

export default EventDetailPage
